import React from 'react';
import PropTypes from 'prop-types';
import IconWithText from '../Icons/IconWithText';

const PasswordRequirements = ({ value }) => {
  const ruleClass = 'password-requirements__rule m-b-1';
  const rulePassedClass = 'password-requirements__rule--passed';

  return (
    <div className="password-requirements m-t-3 m-b-1">
      <span className="like-small m-r-3 m-b-1 float-left">Password requirements:</span>
      <ul className="inline-list-new like-small color-grey">
        <li className={`${ruleClass} ${value.length >= 8 ? rulePassedClass : ''}`}><IconWithText size="s" name="tick" fill="grey">8 characters</IconWithText></li>
        <li className={`${ruleClass} ${/[A-Z]/.test(value) ? rulePassedClass : ''}`}><IconWithText size="s" name="tick" fill="grey">Uppercase</IconWithText></li>
        <li className={`${ruleClass} ${/[a-z]/.test(value) ? rulePassedClass : ''}`}><IconWithText size="s" name="tick" fill="grey">Lowercase</IconWithText></li>
        <li className={`${ruleClass} ${/[0-9]/.test(value) ? rulePassedClass : ''}`}><IconWithText size="s" name="tick" fill="grey">Number</IconWithText></li>
      </ul>
    </div>
  );
};

PasswordRequirements.propTypes = {
  value: PropTypes.string.isRequired,
};

export default PasswordRequirements;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/PasswordRequirements.js